async function devtricker_handle_password_reset_with_code_submission() {

    const resetForm = document.getElementById('resetPasswordForm');
    const resetButton = resetForm.querySelector('button[type="submit"]');
    const codeInput = resetForm.querySelector('input[name="reset_code"]');
    const passwordInput = resetForm.querySelector('input[name="new_password"]');

    resetForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        try {

            devtricker_dom_set_recoverAccountClearError();

            let code = codeInput.value.trim();
            let newPassword = passwordInput.value;

            if (!code || !newPassword) {
                displayResetFeedback('Please fill in all fields.', false);
                return;
            }

            devtricker_dom_set_changeTheContinueButtonToLoading(resetButton, 'Resetting...');

            const login = document.querySelector('#recoverAccountForm input[name="username"]').value.trim();

            const response = await devtricker_ajax_post_reset_password_with_code(login, code, newPassword);

            if (response.success) {
                displayResetFeedback('Your password has been successfully reset. You can now log in.', true);
                resetForm.reset();
                resetForm.style.display = 'none';
            } else {
                displayResetFeedback(response.data.message || 'An error occurred. Please try again.', false);
            }

            devtricker_dom_set_restoreTheContinueButtonToOriginal(resetButton, 'Reset Password');

        } catch (error) {

            devtricker_log(error, devtricker_log_level.ERROR);

            devtricker_dom_set_displayErrorInRecoverAccount('An error occurred. Please try again later..');

            devtricker_dom_set_restoreTheContinueButtonToOriginal(resetButton, 'Reset Password');
        }

    });
}

async function devtricker_handle_password_reset_submission() {
    
    const resetForm = document.getElementById('recoverAccountForm');
    const resetButton = resetForm.querySelector('button[type="submit"]');
    const userInput = resetForm.querySelector('input[name="username"]');

    resetForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        try {

            devtricker_dom_set_recoverAccountClearError();

            let login = userInput.value.trim();

            if (!login) {
                displayResetFeedback('Please enter your username or email address.', false);
                return;
            }

            devtricker_dom_set_changeRecoverAccountButtonToGeneratingPow(resetButton);

            const { pow, pass, duration } = await devtricker_proofOfWorkArgon2idWithWorker();

            devtricker_dom_set_changeTheContinueButtonToLoading(resetButton, g_devtricker_i18n.sending);

            const response = await devtricker_ajax_post_recoverAccount(login, pow, pass, duration);

            if (response.success) {
                displayResetFeedback('Check your email for the password reset code.', true);
                resetForm.style.display = 'none';
                document.getElementById('resetPasswordForm').style.display = 'block';
            } else {
                displayResetFeedback(response.data.message || 'An error occurred. Please try again.', false);
            }

            devtricker_dom_set_restoreTheContinueButtonToOriginal(resetButton, 'Continue');

        } catch (error) {

            devtricker_log(error, devtricker_log_level.ERROR);

            devtricker_dom_set_displayErrorInRecoverAccount('An error occurred. Please try again later.');

            devtricker_dom_set_restoreTheContinueButtonToOriginal(resetButton, 'Continue');
        }

    });
}

async function devtricker_process_account_validateNewEmail() {
    const newEmail = document.getElementById('newEmail');


    const emailVal = newEmail.value.trim();
    const newEmailFeedback = newEmail.nextElementSibling;

    if (!validateEmailFormat(emailVal)) {
        newEmail.classList.add('is-invalid');
        newEmail.classList.remove('is-valid');
        newEmailFeedback.textContent = 'Please enter a valid email address.';
        newEmailFeedback.style.display = 'block';
        return false;
    }

    const isValid = await devtricker_ajax_post_isTheEmailAvailable(emailVal);

    if (!isValid.available) {
        newEmail.classList.add('is-invalid');
        newEmail.classList.remove('is-valid');
        newEmailFeedback.textContent = 'This email is already in use. Please choose another.';
        newEmailFeedback.style.display = 'block';
        return false;
    } else {
        newEmail.classList.remove('is-invalid');
        newEmail.classList.add('is-valid');
        newEmailFeedback.textContent = '';
        newEmailFeedback.style.display = 'none';
        return true;
    }
}

function devtricker_process_account_validateConfirmEmail() {
    const newEmail = document.getElementById('newEmail');
    const confirmEmail = document.getElementById('confirmEmail');

    const emailVal = newEmail.value.trim();
    const confirmEmailVal = confirmEmail.value.trim();
    const confirmEmailFeedback = confirmEmail.nextElementSibling;

    if (emailVal !== confirmEmailVal) {
        confirmEmail.classList.add('is-invalid');
        confirmEmail.classList.remove('is-valid');
        confirmEmailFeedback.textContent = 'Emails do not match. Please confirm your new email.';
        confirmEmailFeedback.style.display = 'block';
        return false;
    } else {
        confirmEmail.classList.remove('is-invalid');
        confirmEmail.classList.add('is-valid');
        confirmEmailFeedback.textContent = '';
        confirmEmailFeedback.style.display = 'none';
        return true;
    }
}

function devtricker_account_hasPasswordToChangeEmail() {
    const currentPasswordToChangeEmail = document.getElementById('currentPasswordToChangeEmail');

    if (currentPasswordToChangeEmail) {
        return currentPasswordToChangeEmail.value.length > 0;
    }
    return false;
}

function devtricker_process_account_validateCurrentPassword() {

    const currentPassword = document.getElementById('currentPassword');

    const currentPasswordVal = currentPassword.value.trim();
    const currentPasswordFeedback = currentPassword.nextElementSibling;

    if (currentPasswordVal === "") {
        currentPassword.classList.add('is-invalid');
        currentPasswordFeedback.textContent = 'Current password is required.';
        currentPasswordFeedback.style.display = 'block';
        return false;
    } else {
        currentPassword.classList.remove('is-invalid');
        currentPasswordFeedback.textContent = '';
        currentPasswordFeedback.style.display = 'none';
        return true;
    }
}

function devtricker_process_account_validateConfirmPassword() {

    const newPassword = document.getElementById('newPassword');
    const confirmPassword = document.getElementById('confirmPassword');

    const newPasswordVal = newPassword.value.trim();
    const confirmPasswordVal = confirmPassword.value.trim();
    const confirmPasswordFeedback = confirmPassword.nextElementSibling;

    if (newPasswordVal !== confirmPasswordVal) {
        confirmPassword.classList.add('is-invalid');
        confirmPassword.classList.remove('is-valid');
        confirmPasswordFeedback.textContent = 'Passwords do not match.';
        confirmPasswordFeedback.style.display = 'block';
        return false;
    } else {
        confirmPassword.classList.remove('is-invalid');
        confirmPassword.classList.add('is-valid');
        confirmPasswordFeedback.textContent = '';
        confirmPasswordFeedback.style.display = 'none';
        return true;
    }
}

function devtricker_process_account_validateNewPassword() {

    const newPassword = document.getElementById('newPassword');

    const newPasswordVal = newPassword.value.trim();
    const newPasswordFeedback = newPassword.nextElementSibling;

    if (!window.zxcvbnLoaded) {
        newPassword.classList.add('is-invalid');
        newPasswordFeedback.textContent = 'Password strength checker is loading. Please wait a moment.';
        newPasswordFeedback.style.display = 'block';
        return false;
    }

    if (newPasswordVal.length === 0) {
        newPassword.classList.add('is-invalid');
        newPasswordFeedback.textContent = 'New password is required.';
        newPasswordFeedback.style.display = 'block';
        return false;
    }

    const result = zxcvbn(newPasswordVal);

    g_devtricker_password_strength = result.score;

    let strengthText = '';
    switch (g_devtricker_password_strength) {
        case 0:
            strengthText = 'Very Weak';
            break;
        case 1:
            strengthText = 'Weak';
            break;
        case 2:
            strengthText = 'Fair';
            break;
        case 3:
            strengthText = 'Strong';
            break;
        case 4:
            strengthText = 'Very Strong';
            break;
        default:
            strengthText = 'Unknown';
    }

    if (g_devtricker_password_strength < 2) {
        newPassword.classList.add('is-invalid');
        newPassword.classList.remove('is-valid');
        newPasswordFeedback.textContent = `Password is too weak (${strengthText}). Try adding more characters or using a mix of letters, numbers, and symbols.`;
        newPasswordFeedback.style.display = 'block';
        return false;
    } else {
        newPassword.classList.remove('is-invalid');
        newPassword.classList.add('is-valid');
        newPasswordFeedback.textContent = "";
        newPasswordFeedback.style.display = 'none';
        return true;
    }
}

function devtricker_showUserSettingsModalToast(toastElement) {
    const offcanvasBody = document.querySelector('#edit-preferences-modal');

    if (offcanvasBody) {
        offcanvasBody.appendChild(toastElement);

        const toast = new bootstrap.Toast(toastElement);
        toast.show();

        setTimeout(() => {
            toastElement.remove();
        }, 2000);
    }
}